import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("ifollowers_lang");
    if (saved) return saved;
    const browser = (navigator.language || navigator.languages?.[0] || "").toLowerCase();
    if (browser.startsWith("ru")) return "ru";
    if (browser.startsWith("he") || browser.startsWith("iw")) return "he";
    if (browser.startsWith("en")) return "en";
    return "he";
  });

  const isRTL = lang === "he";

  useEffect(() => {
    localStorage.setItem("ifollowers_lang", lang);
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang, isRTL]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be inside LanguageProvider");
  return ctx;
}
